<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/productDetail"
          title="产品展示"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          font-size: 0.16rem;
        "
      >
        <el-row style="margin-bottom: 0.35rem">
          <el-col
            :span="24"
            style="display: flex; justify-content: space-between"
          >
            <div
              style="
                width: 4.06rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <el-select
                v-model="formData.parentProductType"
                clearable
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in parentProductTypeList"
                  :label="item.name"
                  :key="index"
                  :value="item.code"
                ></el-option>
              </el-select>
              <div
                style="width: 0.2rem; background-color: #ccc; height: 0.01rem"
              ></div>
              <el-select
                v-loading="childProductLoading"
                v-model="formData.productType"
                placeholder="请选择"
                disabled
                clearable
              >
                <el-option
                  v-for="(item, index) in childProductType"
                  :label="item.name"
                  :key="index"
                  :value="item.code"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <div style="text-align: center">
          <!-- <ComponentProduct
            width="5.86rem"
            :productName="pageData.productName"
            :showTitleOnTop="true"
            :imgUrl="pageData.imgUrl"
          /> -->
          <div
            style="font-weight: bold; margin-bottom: 0.15rem; font-size: 0.2rem"
          >
            {{ pageData.productName }}
          </div>
          <img
            :src="getUrl(pageData.imgUrl)"
            alt="detail"
            style="width: 300px; height: 300px"
          />
        </div>
        <div style="margin-bottom: 0.3rem">
          <div
            style="font-size:16px;font-weight:500;border-bottom:0.1px solid #999;padding-bottom:10px"
          >
            产品描述
          </div>
          <div style="margin-top:10px" v-html="pageData.productDescribe"></div>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.3rem;
          "
        >
          <el-button
            :loading="preBtnLoading"
            @click="lastOne()"
            class="lastBtn"
            v-if="preId"
            plain
            icon="el-icon-arrow-left"
            >上一篇</el-button
          >
          <el-button
            :loading="nextBtnLoading"
            @click="nextOne()"
            v-if="nextId"
            class="nextBtn"
            plain
            >下一篇<i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips
  },
  name: 'ElectromechanicalComponents',
  data() {
    return {
      stepLoading: false,
      pageLoading: false,
      childProductLoading: false,
      childProductType: [],
      activeName: 'productDescribe',
      pageNum: 1,
      pageSize: 10,
      total: 200,
      parentProductTypeList: [],
      productType: [],
      formData: {
        parentProductType: '',
        productType: ''
      },
      pageData: {
        productName: '',
        imgUrl: '',
        specification: '',
        productDescribe: ''
      },
      nextBtnLoading: false,
      preBtnLoading: false,
      currenId: '',
      preId: '',
      nextId: '',
      routerList: []
    };
  },
  created() {
    this.currenId = this.$route.params.id;
    // http.post("/reception/product/getProductCategory", {}).then((res) => {
    //   this.parentProductTypeList = res;
    //   this.childProductType = this.parentProductTypeList[0].subCategory;
    // });
    http.post('/dictionary/getByCode', { groupType: 100 }).then(res => {
      this.parentProductTypeList = res.data;
      this.formData.parentProductType = res.data[0].code;
      this.getData(this.currenId);
    });
    // this.getData(this.currenId);
  },
  methods: {
    getUrl(str) {
      return getFileUrl(str);
    },
    getData(id) {
      this.pageLoading = true;
      http
        .post('/reception/product/getProduct', {
          id
        })
        .then(res => {
          this.pageData = res.data;
          this.preId = res.data.preId;
          this.nextId = res.data.nextId;
          this.formData.parentProductType = res.data.parentProductType;
          http
            .post('/dictionary/getByCode', {
              code: '',
              parentCode: res.data.parentProductType
            })
            .then(r => {
              this.childProductType = r.data;
              this.formData.productType = res.data.productType;
            })
            .then(() => {
              this.childProductLoading = false;
            });
        })
        .finally(() => {
          this.nextBtnLoading = false;
          this.preBtnLoading = false;
          this.pageLoading = false;
        });
    },
    changeParentProductType(val) {
      // this.childProductType = this.parentProductTypeList.filter(
      //   (item) => item.productType === val
      // )[0].subCategory;
      // this.formData.productType = "";
      this.formData.productType = '';
      if (!val) {
        this.childProductType = [];
        return;
      }
      this.getChildProductType();
    },

    lastOne() {
      this.$router.replace({
        path: `/showProduct/productDetail/${this.preId}`
      });
      // this.preBtnLoading = true;
      // this.getData(id);
    },
    nextOne() {
      this.$router.replace({
        path: `/showProduct/productDetail/${this.nextId}`
      });
      // this.nextBtnLoading=true
      // this.getData(id);
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
// * {
//   margin: 0;
//   padding: 0;
// }

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .el-tabs__item:hover {
      color: red;
    }
  }
}
.my-tab {
  ::v-deep .el-tabs__item:hover {
    color: #409eff !important;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #409eff !important;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #409eff !important;
  }
}
</style>
